/**
 * Created by olga on 30.12.2025
 */

const RaveReviewsRowView = function (row) {
    const config = bundles.rave_reviews_scroll_icon.jsons.ravereviewsrowview_prefab_json;
    return Prefab.instantiate(config, { row });
};